import { useState, useEffect } from 'react';
import { Sizes } from '../types-internal/index.js';

function useIsMobile(size = Sizes.MD) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= size);
    useEffect(() => {
        const onResize = () => {
            setIsMobile(window.innerWidth <= size);
        };
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);
    return isMobile;
}

export { useIsMobile as default };
//# sourceMappingURL=useIsMobile.js.map
